/* mell-reveal.js — споделена scroll-reveal анимация за всички Mell секции.
   Намира .mell-rev елементи и им добавя .is-in при влизане във вюпорта.
   Реагира и на shopify:section:load (за Customizer-а). */
(function () {
  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.mell-rev:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', function () { reveal(); });
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
